<div class="dashboard-content-sec">

    <div class="card hide-overflow">
        <app-breadcrumb [crumbList]="crumbList"></app-breadcrumb>
        <div class="card-body pb-0">
            <h5 class="card-title">{{stateRec?.LongName}}</h5>
        </div>
    
        <div class="card-body pb-0">
            <p>{{stateRec?.Overview}}</p>
        </div>
          
        <div class="table-responsive">
            <table id="statesTable" class="table user-table table-striped">
                <thead>
                    <tr class="d-flex">
                        <th scope="col" class="col-2">Title</th>
                        <th scope="col" class="col-5">Law</th>
                        <th scope="col" class="col-5">What To Do</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let update of stateUpdates">
                        <tr class="d-flex">
                            <td class="col-2">
                                {{update.Title}}
                            </td>
                            <td class="col-5">
                                <div [innerHTML] = update.Law></div>
                            </td>
                            <td class="col-5">
                                <div [innerHTML] = update.WhatToDo></div>
                            </td>                               
                        </tr>
                    </ng-container>
                    
                </tbody>
                <ng-container *ngIf="stateUpdates?.length == 0">
                    <tr><td colspan="3">No Result Found</td></tr>
                </ng-container>                                 

            </table>
        </div>
    </div>

</div>